<template>
  <div>
    <div class="container-fluid">
      <div style="" :class="pageClass">
        <div class="content">
          <zoom-center-transition
            :duration="pageTransitionDuration"
            mode="out-in"
          >
            <router-view></router-view>
          </zoom-center-transition>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import { BaseNav } from 'src/components';
import { ZoomCenterTransition } from 'vue2-transitions';

export default {
  components: {
    BaseNav,
    ZoomCenterTransition
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'black'
    }
  },
  data() {
    return {

    };
  },
  computed: {
    title() {
      return `${this.$route.name} Page`;
    }
  },
  methods: {

  },
  beforeDestroy() {

  },
  beforeRouteUpdate(to, from, next) {

  },
  mounted() {

  },
  watch: {

  }
};
</script>
<style lang="scss">

</style>
